import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FaqsComponent implements OnInit {

  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 100,
    totalPages:0
  };
  // row data
  public rows = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue=''
  isFilter:boolean=false
  public columns = [
    { name: "Name", prop: "displayname" },
    { name:"Tag Type",prop:"tagcategories_ids" },
    { name: "Notes", prop: "notes" },
    { name: "Admin Notes", prop: "admin_notes" },
    { name: "Actions", prop: "Actions" },
  ];

  // private
  private tempData = []; 

  imageUrl=environment.apiUrls.imageUrl;
  

  tag_id:any
  searchVal:any;
  @ViewChild('name') inputName
  user_role:any
  tag_cat_list =[]
  selected_tag_cat_id = null
  isTagCat : boolean =false

  guideline_data:any
  course_id:any

  app_data=[]
  s3MediaUrl = environment?.apiUrls?.s3MediaUrl

  constructor( public apiService:ApiService,
               private modalService: NgbModal,
               public toastr: ToastrService,
               private spinner: NgxSpinnerService,private route :Router,
               private activatedroute : ActivatedRoute) { 
                this.user_role=JSON.parse(localStorage.getItem('user'))
                this.activatedroute.paramMap.subscribe(params => { 
                  this.course_id = params.get('id'); 
              });
                // this.course_id = localStorage.getItem('course-id')
              }

  ngOnInit(): void {
    this.getFaqByUser(this.course_id)
    
  }
  getFaqByUser(id){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getAllFaqByCourse(id,'faqs').subscribe((res:any)=>{
      this.spinner.hide();
      this.rows = res?.data?.items
      this.page.totalPages = res?.data?.totalCount
    })
  }
  filter(data){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.filterAssignment(data).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.spinner.hide();
        this.rows = res?.data
        this.page.totalPages = res?.data?.length
      }
    })
  }
  resetFilter(){
    this.inputName.nativeElement.value=''
    this.getFaqByUser(this.course_id.id)
  }

  pageChangeData(page:any){
    this.apiService.getAllFaqByCourse(page.offset +1,page.pageSize).subscribe((res:any)=>{
      this.rows = res?.data?.items
      this.page.totalPages = res?.data?.totalCount
    })
  }
  openContent(content,data) {
    this.app_data = data?.chapters[0]?.topics[0]?.apps
    const options: NgbModalOptions = {
      size: 'lg', // set the size of the modal
      backdrop: 'static', // set whether clicking outside the modal closes it
      centered: true // set whether the modal is centered vertically
    };
    
    const modalRef = this.modalService.open(content,options);
  
    modalRef.result.then((result) => {
    }, (reason) => {
    });
  }
}

